<div class="grid-container padding-y-4">
    <div class="grid-row">
        <div class="grid-col flex-auto">
            <legend class="usa-legend usa-legend--large">Broadcast Messages</legend>
        </div>
    </div>
    <form [formGroup]="broadcastMessagesForm">
        <fieldset class="usa-fieldset">
            <div class="grid-row" *ngIf="isError">
                <div class="usa-alert usa-alert--error usa-alert--slim">
                    <div class="usa-alert__body">
                        <p class="usa-alert__text">
                            {{errorMessage}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-row grid-gap">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <div class="grid-row">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label" for="businesstype">Message Scope<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                            <select id="businesstype" class="maxw-full usa-select" formControlName="businessType">
                                <option value='' selected disabled>Choose...</option>
                                <option value='HHG'>HHG</option>
                                <option value='FRT'>FRT</option>
                                <option value='System'>System wide</option>
                            </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="message_begin_date" class="usa-label">Begin Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                                <input type="text" id="message_begin_date" class="usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="messageBeginDate" (bsValueChange)="messageBeginDateChange($event)" [minDate]="messageBeginMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                                    [value]="this.broadcastMessagesForm.get('messageBeginDate').value | date: 'MMM d, y'" bsDatepicker placement="right">
                                <span class="text-secondary" *ngIf="this.broadcastMessagesForm.get('messageBeginDate').touched && this.broadcastMessagesForm.get('messageBeginDate').hasError('required')">
                                      <br>Messages Begin Date is required.</span>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="message_end_date" class="usa-label">End Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                                <input type="text" id="message_end_date" class="usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="messageEndDate" (bsValueChange)="messageEndDateChange($event)" [minDate]="messageEndMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                                    [value]="this.broadcastMessagesForm.get('messageEndDate').value | date: 'MMM d, y'" bsDatepicker placement="right">
                               <!-- <span class="text-secondary" *ngIf="this.broadcastMessagesForm.get('messageEndDate').touched && this.broadcastMessagesForm.get('messageEndDate').hasError('required')">
                                      <br>Messages End Date is required.</span> -->
                        </div>
                    </div>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <div class="grid-row grid-gap-2">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label for="addlText" class="usa-label">Message to be displayed(Max 200 chars)<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                            <textarea type="text" id="messageText" class="usa-textarea maxw-full" formControlName="messageText" maxlength="200" (change)="onMessageText($event)"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="margin-top-2">
                <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" [disabled] = "updateOrDelete || broadcastMessagesForm.invalid" (click)="createMessages()">Create</button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button" [disabled] = "!updateOrDelete" (click)="updateMessages()">Update</button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--outline" [disabled] = "!updateOrDelete" (click)="deleteMessages()">Delete</button>
                    </li>
                    <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--outline" (click)="clearPage()">Cancel</button>
                    </li>
                </ul>
            </div>
        </fieldset>
    </form>
    
    <div class="margin-top-5">
        <ag-grid-angular class="ag-theme-alpine" [rowData]="messageList" [domLayout]="domLayout" [pagination]="true" [paginationPageSize]="itemsPerPage" [columnDefs]="messageColumnDefs">
        </ag-grid-angular>
    </div>
    
</div>
